import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { getSupabaseClient } from '../lib/supabase';

export function PostHogIdentify() {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    let supabase: ReturnType<typeof getSupabaseClient>;
    try {
      supabase = getSupabaseClient();
    } catch {
      return;
    }

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        try {
          if (event === 'SIGNED_IN' && session?.user) {
            posthog.identify(session.user.id, {
              email: session.user.email,
              role: 'admin',
              app: 'admin',
            });
          }

          if (event === 'SIGNED_OUT') {
            posthog.reset();
          }
        } catch {
          // Analytics identification is non-critical — never break the app
        }
      }
    );

    // Identify on mount if already signed in
    supabase.auth.getUser()
      .then(({ data: { user } }) => {
        if (!user) return;
        try {
          posthog.identify(user.id, {
            email: user.email,
            role: 'admin',
            app: 'admin',
          });
        } catch {
          // Non-critical
        }
      })
      .catch(() => {
        // Non-critical — swallow silently
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [posthog]);

  return null;
}
